import { useQuery } from "@tanstack/react-query";
import { fetchReasons } from "./api";
import { MomentType } from "./types";

export const REASONS_STALE_MS = 5 * 60_000;
/** Mesma raiz que o catálogo do Admin invalida (`WINDOW_REASONS_KEY`). */
export const reasonsKey = (moment: MomentType) => ["reasons", moment] as const;

export function useReasons(moment: MomentType, enabled = true) {
  return useQuery({ queryKey: reasonsKey(moment), queryFn: () => fetchReasons(moment), staleTime: REASONS_STALE_MS, enabled });
}
